module.exports = __webpack_public_path__ + "img/logo_upi_bhim.33934f9d.png";